import { render, staticRenderFns } from "./ImageEnlarge.vue?vue&type=template&id=a0bb991a&scoped=true"
import script from "./ImageEnlarge.vue?vue&type=script&lang=js"
export * from "./ImageEnlarge.vue?vue&type=script&lang=js"
import style0 from "./ImageEnlarge.vue?vue&type=style&index=0&id=a0bb991a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0bb991a",
  null
  
)

export default component.exports